// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__2qn2Z","bigColWidth":"Table_bigColWidth__2jfnh","biggerColWidth":"Table_biggerColWidth__2mdWl","row":"Table_row__2XMPp","col":"Table_col__RXzz3"};